import { createTextarea } from "@gluestack-ui/core/textarea/creator";
import { VariantProps, tva, useStyleContext, withStyleContext } from "@gluestack-ui/utils";
import React from "react";
import { TextInput, View } from "react-native";

const SCOPE = "TEXTAREA";
const UITextarea = createTextarea({
	Root: withStyleContext(View, SCOPE),
	Input: TextInput,
});

const textareaStyle = tva({
	base: "w-full h-[100px] border border-secondary-100 rounded-lg data-[hover=true]:border-secondary-200 data-[focus=true]:border-secondary-500 data-[focus=true]:data-[hover=true]:border-secondary-500 data-[disabled=true]:opacity-40 data-[invalid=true]:border-error-500 data-[invalid=true]:data-[hover=true]:border-error-500 data-[invalid=true]:data-[focus=true]:data-[hover=true]:border-error-500 data-[invalid=true]:data-[focus=true]:data-[hover=true]:web:ring-indicator-primary data-[invalid=true]:data-[disabled=true]:data-[hover=true]:border-error-500",
	variants: {
		size: {
			sm: "",
			md: "",
			lg: "",
			xl: "",
		},
	},
});

const textareaInputStyle = tva({
	base: "p-4 web:outline-0 web:outline-none flex-1 text-neutral-950 align-text-top placeholder:text-secondary-50 web:cursor-text web:data-[disabled=true]:cursor-not-allowed",
	parentVariants: {
		size: {
			sm: "text-sm",
			md: "text-base",
			lg: "text-lg",
			xl: "text-xl p-5",
		},
	},
});

export type ITextareaProps = React.ComponentProps<typeof UITextarea> & VariantProps<typeof textareaStyle>;

const Textarea = React.forwardRef<React.ComponentRef<typeof UITextarea>, ITextareaProps>(function Textarea(
	{ className, size = "md", ...props },
	ref,
) {
	return <UITextarea ref={ref} {...props} className={textareaStyle({ class: className })} context={{ size }} />;
});

type ITextareaInputProps = React.ComponentProps<typeof UITextarea.Input> & VariantProps<typeof textareaInputStyle>;

const TextareaInput = React.forwardRef<React.ComponentRef<typeof UITextarea.Input>, ITextareaInputProps>(
	function TextareaInput({ className, ...props }, ref) {
		const { size: parentSize } = useStyleContext(SCOPE);

		return (
			<UITextarea.Input
				ref={ref}
				{...props}
				className={textareaInputStyle({
					parentVariants: {
						size: parentSize,
					},
					class: className,
				})}
			/>
		);
	},
);

Textarea.displayName = "Textarea";
TextareaInput.displayName = "TextareaInput";

export { Textarea, TextareaInput };
